import { render } from "./RejectConfirmModal.vue?vue&type=template&id=40da8e3b"
import script from "./RejectConfirmModal.vue?vue&type=script&lang=ts"
export * from "./RejectConfirmModal.vue?vue&type=script&lang=ts"
script.render = render

export default script